import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Chrome fires this when a ResizeObserver callback affects layout in the same frame.
// It is benign; suppress it so CRA's dev overlay does not treat it as a fatal error.
window.addEventListener('error', (event) => {
  const message = event?.message || '';
  if (message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

